import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CatalogItem, RoutingTable } from '@shared';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RoutingTableService {
  private catalogsPath: string = `${environment.apiBasePath}${environment.catalogsPath}`;
  private routingTablePath: string = `${this.catalogsPath}/edit/routingTable`;

  constructor(private http: HttpClient) {}

  public getAllRoutingTable(): Observable<RoutingTable[]> {
    return this.http.get<RoutingTable[]>(`${this.routingTablePath}/list`);
  }

  public getRoutingTableData(
    entity: 'Country' | 'BusinessUnit' | 'Categories' | 'SubCategory'
  ): Observable<CatalogItem[]> {
    return this.http.get<CatalogItem[]>(`${this.catalogsPath}/${entity}`);
  }

  public modifyRoutingTable(
    operation: 'New' | 'Delete' | 'Edit',
    body: RoutingTable[]
  ): Observable<{ message: string } | { error: string }[]> {
    body.forEach((item) => (item.operation = operation));
    return this.http.put<{ message: string }>(this.routingTablePath, body);
  }
}
